module.exports = __webpack_public_path__ + "static/img/service-head.60d2ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-head.jpg
// module id = 9mdy
// module chunks = 10